module.exports = __webpack_public_path__ + "img/国际公法.b5731766.png";